import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './LoadoutLabel.module.scss';

export type LoadoutLabelVariant = 'caption' | 'plate';

interface LoadoutLabelProps {
    /** `caption` sits on the container frame; `plate` sits on a label plate. */
    variant?: LoadoutLabelVariant;
    /** Positioning is up to the parent. */
    className?: string;
    children: ReactNode;
}

/** Text label sized against the Loadout's container (cqw), so it scales with the frame. */
export function LoadoutLabel({ variant = 'caption', className, children }: LoadoutLabelProps): JSX.Element {
    return <span className={classNames(styles.label, styles[variant], className)}>{children}</span>;
}
